import React, { useEffect } from 'react';
import { Trans } from 'react-i18next';
import { staticURL } from 'core/url';
import { WikiWrapper } from 'apps/components';
import { useRouterStore } from 'apps/hooks';
import { clientStore } from 'apps/client/app';

export const CheckEmail = () => {
  const { route } = useRouterStore();
  const { email } = route.params;

  const checkProfileConfirmed = async () => {
    await clientStore.WhoAmI();
    if (!clientStore.profileResponse) return;

    const { profileConfirmed, user } = clientStore.profileResponse;

    if (user?.emailStatus === 'CONFIRMED' || profileConfirmed) {
      clientStore.routerStore.navigate('home');
    }
  };

  useEffect(() => {
    checkProfileConfirmed();
  }, []);

  const handleLogout = () => {
    clientStore.routerStore.navigate('home.signUp');
  };

  return (
    <WikiWrapper>
      <div className='flex flex-y-center flex-grow'>
        <img width={64} src={staticURL('assets/icons/checkbox.svg')} />
        <p className='font-bold text-2xl text-black'>Check your inbox</p>
        <p className='my-6 text-lg text-black flex-y-center text-center flex-wrap'>
          Please verify your email by clicking on the link we sent to{' '}
          {email ? (
            <div className='font-bold flex justify-center'>{email}</div>
          ) : (
            'email'
          )}
        </p>

        {email ? (
          <div className='flex-center text-center flex-wrap text-black'>
            <p>
              Wrong Address? &nbsp;
              <a onClick={handleLogout} className='cursor-pointer'>
                <Trans>Log out </Trans>
              </a>
              to sign up/in with a different email.
            </p>
          </div>
        ) : null}
      </div>
    </WikiWrapper>
  );
};
